import useTranslation from 'next-translate/useTranslation';

// Hooks
import { useSearchBoxContext } from '@/utils/hooks/context/searchBox/useSearchBoxContext';

// Types
import type { SocialProfileFormattedType } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/ProfilesTab';
import type { GroupsFormattedType } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/GroupsTab';

// Components
import { SelectSortItem } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/SelectSortItem';

type SearchListWrapperProps = {
    children: React.ReactNode;
    no_data_message: string;
    type: 'profiles' | 'groups';
};

export function SearchListWrapper<
    TContext extends SocialProfileFormattedType | GroupsFormattedType
>({ children, no_data_message, type }: SearchListWrapperProps) {
    const { t } = useTranslation('commons');
    const { dataContext, dispatch } = useSearchBoxContext<TContext>();
    const { disabled, filteredData, isMultiSelect } = dataContext;

    if (!filteredData.length) {
        return (
            <div
                className="scrollbar flex flex-1 flex-col items-center justify-center px-5 text-sm"
                data-testid="no-options">
                <div className="text-center text-icoGray-400 dark:text-icoDarkMode-wolf">
                    {no_data_message}
                </div>
            </div>
        );
    }

    const isAllSelected = Boolean(!(filteredData ?? [])?.find((item) => !item.selected));

    return (
        <>
            <div className="flex justify-between px-5 pb-2 text-xxs">
                <div>
                    <SelectSortItem type={type} />
                </div>
                {isMultiSelect ? (
                    <button
                        data-testid={
                            isAllSelected ? 'search-box-unselect-all' : 'search-box-select-all'
                        }
                        disabled={disabled}
                        onClick={() => {
                            if (!isAllSelected) {
                                return dispatch({ type: 'SELECT_ALL' });
                            }

                            dispatch({ type: 'UNSELECT_EXPECT_FIRST_ONE' });
                        }}
                        className="text-icoBlue">
                        {isAllSelected ? t('unselect_all') : t('select_all')}
                    </button>
                ) : null}
            </div>
            <div className="scrollbar flex flex-1 flex-col gap-2 px-5">{children}</div>
        </>
    );
}
